Object.defineProperty(exports, "__esModule", { value: true });
var Sequence_1 = require("./Sequence");
var DistinctIterator = /** @class */ (function () {
    function DistinctIterator(iterator) {
        this.iterator = iterator;
        this.items = [];
    }
    DistinctIterator.prototype.next = function (value) {
        for (var item = this.iterator.next(); !item.done; item = this.iterator.next()) {
            if (this.items.indexOf(item.value) < 0) {
                this.items.push(item.value);
                return { done: false, value: item.value };
            }
        }
        return { done: true, value: undefined };
    };
    return DistinctIterator;
}());
var Distinct = /** @class */ (function () {
    function Distinct() {
    }
    /**
     * Returns a new sequence which discards all duplicate elements.
     *
     * @returns {Sequence<T>}
     */
    Distinct.prototype.distinct = function () {
        return Sequence_1.createSequence(new DistinctIterator(this.iterator));
    };
    return Distinct;
}());
exports.Distinct = Distinct;
//# sourceMappingURL=distinct.js.map